module.exports = "/images/login-page-bg.png?e0d277f3fa8e574427cb78422b621daf";